module.exports = __webpack_public_path__ + "img/10.730497b6.jpg";